<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('tips_search') || '转库单编号/转入库位名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                    >{{ $l('INDEX.advanced_search') || '高级搜索' }}</b-button
                  >
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.Status') || '有效状态'">
              <el-checkbox-group v-model="form.cartonTransferStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.bill_status_new') || '新增'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.bill_status_reviewed') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.order_status_D') || '已删除'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_billCartonTransferNo') || '纸箱转库单编号'"
            >
              <el-input
                v-model.trim="form.billCartonTransferNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_inLocationFullName') || '转入库位名称'"
            >
              <el-input
                v-model.trim="form.inLocationFullName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_transferDate') || '转库日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.transferDateBegin"
                      type="datetime"
                      size="small"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.transferDateEnd"
                      type="datetime"
                      size="small"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createTimeBegin"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('INDEX.table_label_modification_date') || '修改时间'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeBegin"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  cartonTransferStatusList: ['Y', 'N'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'samplemanage-cartonTransfer-detail',
        params: { ...params, pageType },
      })
    },
    getForm() {
      return this.form
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
